import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ScrollText, Mail, ShieldCheck, ArrowRight } from "lucide-react";

export default function Register() {
  return (
    <div className="min-h-screen paper flex items-center justify-center px-6">
      <div className="max-w-lg w-full">
        <div className="flex items-center gap-2 mb-6 justify-center text-primary">
          <ScrollText className="w-6 h-6"/>
          <span className="font-display text-2xl">GrantForge</span>
        </div>
        <div className="card-crisp rounded-lg p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-primary/10 text-primary grid place-items-center mx-auto mb-4">
            <Mail className="w-7 h-7"/>
          </div>
          <div className="overline">Access is by invitation</div>
          <h1 className="font-display text-3xl mt-2 leading-tight">Contact the administrator for access</h1>
          <p className="text-muted-foreground mt-3 text-sm leading-relaxed">
            GrantForge is a curated platform. New accounts are provisioned by our team so you get onboarded, matched to the right toolkit, and given a working seat from day one.
          </p>
          <div className="mt-5 border border-dashed border-primary/40 bg-primary/5 rounded-md p-3 text-sm flex items-start gap-3 text-left">
            <ShieldCheck className="w-5 h-5 text-primary shrink-0 mt-0.5"/>
            <div>
              Email <a href="mailto:hello@grantforge.io" className="text-primary hover:underline">hello@grantforge.io</a> with your name, institution and discipline. You'll receive your login credentials by return mail — usually within one business day.
            </div>
          </div>
          <div className="mt-6 flex flex-col gap-2">
            <Button disabled className="rounded-full w-full opacity-50 cursor-not-allowed" data-testid="register-disabled">
              Registration is closed — contact admin for access
            </Button>
            <Link to="/login" className="text-sm text-primary hover:underline inline-flex items-center gap-1 justify-center mt-2" data-testid="back-to-login">
              Already have credentials? Sign in <ArrowRight className="w-3 h-3"/>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
